import { IMonitoringRepository } from "../../../domain/monitoring/monitoring-repository";
import { ReportsService } from "../../../services/reports.service";

export class MonitoringStatusViewModel {
  public selectedAvailabilityZones: MonitoringAvailabilityZoneInfo[] = [];
  public allAvailabilityZones: MonitoringAvailabilityZoneInfo[] = [];

  public availabilityZonesChartUrl: string;
  public selectedTimeMins: number = 60;

  constructor(
    private _reportService: ReportsService,
    private _monitoringRepository: IMonitoringRepository,
  ) {}

  public OnInit(): void {
    this.loadAvailabilityZonesReport();
  }

  public loadAvailabilityZonesReport() {
    const selectedAvailabilityZoneIds = this.selectedAvailabilityZones.map(
      (z) => z.id,
    );
    this._reportService.getAZStatusesReport().then((response) => {
      this.allAvailabilityZones = response
        .filter((z) => z.IsOnline)
        .map(
          (r) =>
            new MonitoringAvailabilityZoneInfo(
              r.AvailabilityZoneId,
              r.DisplayName,
              r.HtmlColor,
              r.IsOnline,
              r.RenderersCount,
              selectedAvailabilityZoneIds.includes(r.AvailabilityZoneId),
            ),
        );
    });
  }

  public onAvailabilityZoneChanged(az: MonitoringAvailabilityZoneInfo) {
    az.selected = !az.selected;
    this.selectedAvailabilityZones = this.allAvailabilityZones.filter(
      (z) => z.selected,
    );
    this.getAvailabilityZonesChartUrl();
  }

  public getAvailabilityZonesChartUrl(): void {
    let vertLineEvery = 10;
    let timeTagFormat = "HH:mm";
    let hoursInstead = false;

    if (this.selectedTimeMins === 60 * 24 || this.selectedTimeMins === 60 * 6) {
      vertLineEvery = 1;
      hoursInstead = true;
    } else if (this.selectedTimeMins === 60 * 24 * 7) {
      vertLineEvery = 24;
      hoursInstead = true;
      timeTagFormat = "dd MMMM";
    }
    this.availabilityZonesChartUrl =
      this._monitoringRepository.generateAvailabilityChartUrl(
        this.selectedAvailabilityZones.map((z) => z.id),
        1920,
        1080,
        this.selectedTimeMins,
        this.selectedTimeMins * 60,
        timeTagFormat,
        vertLineEvery,
        hoursInstead,
      );
  }

  public static LastState: MonitoringStatusViewModel;
}
export class MonitoringAvailabilityZoneInfo {
  constructor(
    public id: number,
    public displayName: string,
    public colorHex: string,
    public isOnline: boolean = false,
    public renderersCount: number = 0,
    public selected: boolean = false,
  ) {}
}
